import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import TemperatureBox from "../Components/TemperatureBox";
import { GetLatestPoolTemperatures } from "../Components/APICalls";

const allPoolTemperatureData = [];

export default function EastMaitlandPool() {
    // Create state data for pool temperatures
    const [poolTemperatureData, setPoolTemperatureData] = useState(allPoolTemperatureData);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Run API Call
        const RunLatestPoolTemperatures = async () => {
            var response = await GetLatestPoolTemperatures();   

            response.forEach((item) => {
                if (item.poolLocationID === "EMOP") {
                    allPoolTemperatureData.push({
                        poolTemperatureID: item.poolTemperatureID,
                        poolTemperature: item.poolTemperature,
                        poolLocationID: item.poolLocationID,
                        poolLocationName: item.poolLocationName,
                        notes: item.notes,
                        createdBy: item.createdBy,
                        createdDateTime: item.createdDateTime
                    });
                }
            });

            setPoolTemperatureData(allPoolTemperatureData);
            setIsLoading(false);

            return response;
        }

        if (allPoolTemperatureData.length === 0) {
            RunLatestPoolTemperatures();
        } else {
            if (isLoading === true) {
                setIsLoading(false);
            }
        }
    // eslint-disable-next-line
    }, []);

    return(
        <>
        {!isLoading && 
        <>
            {/* Use Boxes as spacers for styling */}
            { poolTemperatureData.map( allPoolTemperatureData => (
                <>
                    <Box height='1vh'></Box>
                    <TemperatureBox boxViewHeight='98vh' poolName={allPoolTemperatureData.poolLocationName} 
                        poolTemperature={allPoolTemperatureData.poolTemperature} notes={allPoolTemperatureData.notes}
                        createdDateTime={allPoolTemperatureData.createdDateTime} />
                </>
            ))}
        </>}
    </>
    );
}